package common.animation.loadingspinner

data class LoadingSpinnerState(
    val mIsRollerColorPainted: Boolean = false
)